import { render, staticRenderFns } from "./register-1.vue?vue&type=template&id=692835f2"
import script from "./register-1.vue?vue&type=script&lang=js"
export * from "./register-1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports